export { DefaultLayoutComponent } from '../components/default-layout/default-layout.component';
